import React, {useContext, useState} from 'react'
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"
import StadisticCard from './StadisticCard';
import PropTypes from 'prop-types';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';
import List from '../../../../Templates/List';
import ListPagination from '../../../../Templates/List/ListPagination';
import NoDataLayer from '../../../../Common/NoDataLayer';
import GapActionCard from '../GapActionCard/GapActionCard';
import './style.css'
import { ScrollablePane, ScrollbarVisibility, Toggle } from '@fluentui/react';
import { useGetListLastActions } from '../../../../../hooks/services/sKPI/useOfGAP';

function GapActionStadistic(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        
        inputParam_DataList = null,
    } = props;

    const [selectedItem, setSelectedItem] = useState(null);
    const [fire, setFire] = useState(true);
    const [tglShowMyActionsValue, setTglShowMyActionsValue] = useState(false);
    
    const [actionList, setActionList] = useState(__OBJECT_STRUCTURE_GetList(10));
    const [numberOfItems, setNumberOfItems] = useState(actionList.pageSize);
    useGetListLastActions(inputParam_GapAnalyzeId, actionList, setActionList, null, setNumberOfItems);

    let totalItemsList = 0;
    let accomplishedItemsList = 0;
    let committedItemsList = 0;
    let expiredItemsList = 0;

    if (actionList.data !== null) {
        totalItemsList = actionList.data.length;
        accomplishedItemsList = actionList.data.filter(x => x.statusId === 2).length;
        committedItemsList = actionList.data.filter(x => x.statusId === 3).length;
        expiredItemsList = actionList.data.filter(x => x.statusId === 4).length;
    }

    const container = {
        display: "flex",
        justifyContent: "center",
        margin: "0"
    };

    const cards = [
        { class: "col", title: t('data-lang-lbl-totalactions'), type: "isTotal", amount: totalItemsList, icon: "Documentation", color: "#a1a1a1", display: true },
        { class: "col", title: t('data-lang-lbl-accomplishedactions'), type: "isSended", amount: accomplishedItemsList, icon: "DocumentApproval", color: "#7FD7A7", display: true },
        { class: "col", title: t('data-lang-lbl-committedactions'), type: "isReceived", amount: committedItemsList, icon: "SurveyQuestions", color: "#A1B8E1", display: true },
        { class: "col", title: t('data-lang-lbl-expiredactions'), type: "isExpired", amount: expiredItemsList, icon: "FileBug", color: "#FF7F7F", display: true },
    ];

    
    const onShowMyActionsChange = (e, checked) => {
        setTglShowMyActionsValue(checked);
        setFire(true)
    };

    return (
        <Card className='h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{ t('data-lang-boxname-actionstadistic') }</b>
                    <Toggle
                        checked={ tglShowMyActionsValue }
                        onChange={ onShowMyActionsChange }
                        role="checkbox"
                        onText={ t('data-lang-lbl-myactions') }
                        offText={ t('data-lang-lbl-allactions')}
                        styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                    />
                </Card.Title>
            </Card.Header>
            <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <div className='book-toolbar d-flex float-end'>
                </div>
            </Card.Footer>
            <Card.Body>
                <Row className="p-0 pb-2" style={ container }>
                    {
                        cards.map((card, index) => (
                            card.display &&
                            <div key={index} className={`${card.class} ${card.display ? "d-unset" : "d-none"}`} style={{padding: "0px", minWidth: "70px"}} >
                                <StadisticCard
                                    inputParam_Item={ card }
                                    inputParam_ArrayLength={ 4 }
                                    inputParam_Index={index}
                                    inputParam_SelectedItem={selectedItem}
                                    inputParam_SetterSelectedItem={setSelectedItem}
                                />
                            </div>
                        ))
                    }
                </Row>
                <Row className='pt-2 border-top'>
                    <Col id="listActionStatistic">
                        {
                            actionList.data &&
                            <ScrollablePane
                                style={{minHeight: "170px", maxHeight: "100%", height: "100%"}}
                                styles={{
                                    root: { position: "relative" },
                                    contentContainer:{overflowX: "hidden"}
                                }}
                                scrollbarVisibility={ScrollbarVisibility.auto}
                                scrollContainerFocus={true}
                            >
                                <List
                                    manipulateLocalData={ true }
                                    className="no-compact-list"
                                    showHeaders={ false }
                                    isHeaderVisible={ false }
                                    listLocalStoragePageSizeVariableName="actionstadisctic"
                                    data={actionList}
                                    setData={setActionList}
                                    columns={[
                                        {  
                                            key: 'title',
                                            name: t('data-lang-lbl-data'),
                                            fieldName: 'title',
                                            onRender:(item, row) => {
                                                return <GapActionCard
                                                            inputParam_EditMode={false}
                                                            inputParam_GapElementId={'#4'}
                                                            inputParam_ActionItem={item}
                                                            inputParam_ShowSeparatorStyle={false}
                                                            inputParam_ShowCause={true}
                                                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                            inputParam_GapRevisionId={inputParam_GapRevisionId}
                                                            inputParam_Dflex_Buttons={true}
                                                        />
                                            }
                                        }  
                                    ]} />
                            </ScrollablePane>
                        }
                    <NoDataLayer display={ actionList.data === null } />
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer>
                <ListPagination
                    listLocalStoragePageSizeVariableName="actionstadisctic"
                    data={actionList}
                    setData={setActionList}
                />
            </Card.Footer>
        </Card>
    );
}

///Proptypes
GapActionStadistic.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number,
    
    inputParam_DataList: PropTypes.array,
};

export default GapActionStadistic;

